<template>
  <div>
    <div class="101">
      <!-- body-->
      <div class="body">
        <img src="./img/0_1_1.jpg" />
        <img src="./img/0_1_2.jpg" />
        <img src="./img/0_1_3.jpg" />
        <img src="./img/0_1_4.jpg" />
        <img src="./img/0_1_5.jpg" />
        <img src="./img/1_1_1.jpg" @click="path(brandEnum.himo,102961)" />
        <img src="./img/1_2_1.jpg" @click="path(brandEnum.himo,103440)" />
        <img src="./img/1_3_1.jpg" @click="path(brandEnum.himo,106968)" />
        <img src="./img/1_4_1.jpg" @click="path(brandEnum.himo,102313)" />
        <img src="./img/1_5_1.jpg" @click="path(brandEnum.himo,95072)" />
        <img src="./img/1_6_1.jpg" @click="path(brandEnum.master,107904)" />
        <img src="./img/1_7_1.jpg" @click="path(brandEnum.master,93475)" />
        <img src="./img/1_8_1.jpg" @click="path(brandEnum.master,106234)" />
        <img src="./img/1_9_1.jpg" @click="path(brandEnum.master,28420)" />
        <img src="./img/1_10_1.jpg" @click="path(brandEnum.master,93193)" />
        <img src="./img/1_11_1.jpg" @click="path(brandEnum.master,27184)" />
        <img src="./img/1_12_1.jpg" />
        <img src="./img/1_13_1.jpg" @click="path(brandEnum.himo,99426)" />
        <img src="./img/1_14_1.jpg" @click="path(brandEnum.himo,97019)" />
        <img src="./img/1_15_1.jpg" @click="path(brandEnum.master,108058)" />
        <div v-if="$route.query.isMt">
          <img src="./img/1_16_1.jpg" @click="path(brandEnum.mantu,107369)" />
          <img src="./img/1_17_1.jpg" @click="path(brandEnum.mantu,107403)" />
        </div>
        <img src="./img/1_18_1.jpg" />
        <img src="./img/1_19_1.jpg" />
      </div>
      <!-- popup-->
      <div class="popup">
        <img class="button unShow" src="./img/1_24_1.png" @click="open" />
        <div class="pop-img-view unShow" v-if="isShow" @click.self="close">
          <img src="./img/1_25_1.png" />
          <img src="./img/1_26_1.png" class="close" @click.stop="close" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isInWxMP } from "@/util";

const weixin = isInWxMP();
const isMiniApp = weixin || weixin.length || window.my || window.tt;
import _ from "lodash";

export default {
  data() {
    return {
      brandEnum: {
        himo: "himo",
        family: "family",
        master: "master",
        mantu: "mantu"
      },
      isShow: false,
      isMiniApp: isMiniApp
    };
  },
  methods: {
    open() {
      this.isShow = true;
    },
    close() {
      this.isShow = false;
    },
    path(type, prodId) {
      if (this.isMiniApp) {
        this.miniAppPath(type, prodId);
      } else {
        this.wxPath(type, prodId);
      }
    },
    wxPath(type, prodId) {
      const appName = this.getMiniAppName(type);
      const path = this.getMiniAppHref(type);
      const query = this.getMiniAppQuery(type, prodId);
      window.location.href = `https://m.haimati.cn/common-h5/index.html#/wxUrlScheme?appName=${appName}&path=${path}&query=${query}`;
    },
    miniAppPath(brand, prodId) {
      const path = this.getMiniAppHref(brand);
      const query = this.getMiniAppQuery(brand, prodId);
      const url = decodeURIComponent(path) + "?" + decodeURIComponent(query);
      if (brand === this.brandEnum.mantu) {
        window.wx.miniProgram.navigateTo({
          url: `/pages/webview/jump?appId=wx295fb795503abb3c&${url}`
        });
      } else {
        if (window.wx) {
          if (_.isEmpty(window.wx.miniProgram))
            return window.wx.navigateTo({ url });
          return window.wx.miniProgram.navigateTo({ url });
        } else if (window.tt) {
          return window.tt.miniProgram.navigateTo({ url });
        } else if (xhs) {
          return xhs.miniProgram.navigateTo({ url });
        }
      }
    },
    getMiniAppName(brand) {
      if (brand === this.brandEnum.himo || brand === this.brandEnum.master)
        return "himo_app";
      if (brand === this.brandEnum.mantu) return "mantu_mini_program";
    },
    getMiniAppHref(brand) {
      if (brand === this.brandEnum.himo || brand === this.brandEnum.master)
        return encodeURIComponent("/pagesA/product/prodDetail/index");
      if (brand === this.brandEnum.mantu)
        return encodeURIComponent("/pages/product/product");
    },
    getMiniAppQuery(brand, prodId) {
      if (brand === this.brandEnum.himo || brand === this.brandEnum.master)
        return encodeURIComponent(
          `brand=${
            brand === this.brandEnum.master ? "gold" : "blue"
          }&showPid=${prodId}&pickPid=${prodId}`
        );
      if (brand === this.brandEnum.mantu)
        return encodeURIComponent(`id=${prodId}`);
    }
  }
};
</script>
<style lang="less" scoped>
.body {
  height: 100vh;
  overflow-y: scroll;

  .flex_box {
    display: flex;
    width: 100vw;
    height: 8.38rem;

    img {
      display: flex;
    }

    .max {
      width: 55%;
    }

    .min {
      width: 45%;
    }
  }

  img {
    display: flex;
    width: 100vw;
  }
}

.popup {
  .button {
    position: fixed;
    right: 10px;
    bottom: 90px;
    z-index: 2;
    width: 81px;
    height: 79px;
  }

  .pop-img-view {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 3;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.65);

    img {
      width: 375px;
    }

    .close {
      width: 35px !important;
      height: 35px !important;
    }
  }

  .unShow {
    animation: go_out 0.2s;
  }

  @keyframes go_out {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
}
</style>
